import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _NATIVE_CURRENCY, _WRAPPED_NATIVE_CURRE;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Ether, NativeCurrency, Token } from '@uniswap/sdk-core';
import { WGLMR_MOONBEAM, WXDAI_GNOSIS } from '../providers';
export var ChainId;

(function (ChainId) {
  ChainId[ChainId["MAINNET"] = 1] = "MAINNET";
  ChainId[ChainId["ROPSTEN"] = 3] = "ROPSTEN";
  ChainId[ChainId["RINKEBY"] = 4] = "RINKEBY";
  ChainId[ChainId["G\xD6RLI"] = 5] = "G\xD6RLI";
  ChainId[ChainId["KOVAN"] = 42] = "KOVAN";
  ChainId[ChainId["OPTIMISM"] = 10] = "OPTIMISM";
  ChainId[ChainId["OPTIMISTIC_KOVAN"] = 69] = "OPTIMISTIC_KOVAN";
  ChainId[ChainId["ARBITRUM_ONE"] = 42161] = "ARBITRUM_ONE";
  ChainId[ChainId["ARBITRUM_RINKEBY"] = 421611] = "ARBITRUM_RINKEBY";
  ChainId[ChainId["POLYGON"] = 137] = "POLYGON";
  ChainId[ChainId["POLYGON_MUMBAI"] = 80001] = "POLYGON_MUMBAI";
  ChainId[ChainId["CELO"] = 42220] = "CELO";
  ChainId[ChainId["CELO_ALFAJORES"] = 44787] = "CELO_ALFAJORES";
  ChainId[ChainId["GNOSIS"] = 100] = "GNOSIS";
  ChainId[ChainId["MOONBEAM"] = 1284] = "MOONBEAM";
})(ChainId || (ChainId = {})); // WIP: Gnosis, Moonbeam


export var SUPPORTED_CHAINS = [ChainId.MAINNET, ChainId.RINKEBY, ChainId.ROPSTEN, ChainId.KOVAN, ChainId.OPTIMISM, ChainId.OPTIMISTIC_KOVAN, ChainId.ARBITRUM_ONE, ChainId.ARBITRUM_RINKEBY, ChainId.POLYGON, ChainId.POLYGON_MUMBAI, ChainId.GÖRLI, ChainId.CELO_ALFAJORES, ChainId.CELO // Gnosis and Moonbeam don't yet have contracts deployed yet
];
export var V2_SUPPORTED = [ChainId.MAINNET, ChainId.KOVAN, ChainId.GÖRLI, ChainId.RINKEBY, ChainId.ROPSTEN];
export var HAS_L1_FEE = [ChainId.OPTIMISM, ChainId.OPTIMISTIC_KOVAN, ChainId.ARBITRUM_ONE, ChainId.ARBITRUM_RINKEBY];
export var NETWORKS_WITH_SAME_UNISWAP_ADDRESSES = [ChainId.MAINNET, ChainId.ROPSTEN, ChainId.RINKEBY, ChainId.GÖRLI, ChainId.KOVAN, ChainId.OPTIMISM, ChainId.OPTIMISTIC_KOVAN, ChainId.ARBITRUM_ONE, ChainId.ARBITRUM_RINKEBY, ChainId.POLYGON, ChainId.POLYGON_MUMBAI];
export var ID_TO_CHAIN_ID = function ID_TO_CHAIN_ID(id) {
  switch (id) {
    case 1:
      return ChainId.MAINNET;

    case 3:
      return ChainId.ROPSTEN;

    case 4:
      return ChainId.RINKEBY;

    case 5:
      return ChainId.GÖRLI;

    case 42:
      return ChainId.KOVAN;

    case 10:
      return ChainId.OPTIMISM;

    case 69:
      return ChainId.OPTIMISTIC_KOVAN;

    case 42161:
      return ChainId.ARBITRUM_ONE;

    case 421611:
      return ChainId.ARBITRUM_RINKEBY;

    case 137:
      return ChainId.POLYGON;

    case 80001:
      return ChainId.POLYGON_MUMBAI;

    case 42220:
      return ChainId.CELO;

    case 44787:
      return ChainId.CELO_ALFAJORES;

    case 100:
      return ChainId.GNOSIS;

    case 1284:
      return ChainId.MOONBEAM;

    default:
      throw new Error("Unknown chain id: ".concat(id));
  }
};
export var ChainName;

(function (ChainName) {
  ChainName["MAINNET"] = "mainnet";
  ChainName["ROPSTEN"] = "ropsten";
  ChainName["RINKEBY"] = "rinkeby";
  ChainName["G\xD6RLI"] = "goerli";
  ChainName["KOVAN"] = "kovan";
  ChainName["OPTIMISM"] = "optimism-mainnet";
  ChainName["OPTIMISTIC_KOVAN"] = "optimism-kovan";
  ChainName["ARBITRUM_ONE"] = "arbitrum-mainnet";
  ChainName["ARBITRUM_RINKEBY"] = "arbitrum-rinkeby";
  ChainName["POLYGON"] = "polygon-mainnet";
  ChainName["POLYGON_MUMBAI"] = "polygon-mumbai";
  ChainName["CELO"] = "celo-mainnet";
  ChainName["CELO_ALFAJORES"] = "celo-alfajores";
  ChainName["GNOSIS"] = "gnosis-mainnet";
  ChainName["MOONBEAM"] = "moonbeam-mainnet";
})(ChainName || (ChainName = {}));

export var NativeCurrencyName;

(function (NativeCurrencyName) {
  // Strings match input for CLI
  NativeCurrencyName["ETHER"] = "ETH";
  NativeCurrencyName["MATIC"] = "MATIC";
  NativeCurrencyName["CELO"] = "CELO";
  NativeCurrencyName["GNOSIS"] = "XDAI";
  NativeCurrencyName["MOONBEAM"] = "GLMR";
})(NativeCurrencyName || (NativeCurrencyName = {}));

export var NATIVE_CURRENCY = (_NATIVE_CURRENCY = {}, _defineProperty(_NATIVE_CURRENCY, ChainId.MAINNET, NativeCurrencyName.ETHER), _defineProperty(_NATIVE_CURRENCY, ChainId.ROPSTEN, NativeCurrencyName.ETHER), _defineProperty(_NATIVE_CURRENCY, ChainId.RINKEBY, NativeCurrencyName.ETHER), _defineProperty(_NATIVE_CURRENCY, ChainId.GÖRLI, NativeCurrencyName.ETHER), _defineProperty(_NATIVE_CURRENCY, ChainId.KOVAN, NativeCurrencyName.ETHER), _defineProperty(_NATIVE_CURRENCY, ChainId.OPTIMISM, NativeCurrencyName.ETHER), _defineProperty(_NATIVE_CURRENCY, ChainId.OPTIMISTIC_KOVAN, NativeCurrencyName.ETHER), _defineProperty(_NATIVE_CURRENCY, ChainId.ARBITRUM_ONE, NativeCurrencyName.ETHER), _defineProperty(_NATIVE_CURRENCY, ChainId.ARBITRUM_RINKEBY, NativeCurrencyName.ETHER), _defineProperty(_NATIVE_CURRENCY, ChainId.POLYGON, NativeCurrencyName.MATIC), _defineProperty(_NATIVE_CURRENCY, ChainId.POLYGON_MUMBAI, NativeCurrencyName.MATIC), _defineProperty(_NATIVE_CURRENCY, ChainId.CELO, NativeCurrencyName.CELO), _defineProperty(_NATIVE_CURRENCY, ChainId.CELO_ALFAJORES, NativeCurrencyName.CELO), _defineProperty(_NATIVE_CURRENCY, ChainId.GNOSIS, NativeCurrencyName.GNOSIS), _defineProperty(_NATIVE_CURRENCY, ChainId.MOONBEAM, NativeCurrencyName.MOONBEAM), _NATIVE_CURRENCY);
export var ID_TO_NETWORK_NAME = function ID_TO_NETWORK_NAME(id) {
  switch (id) {
    case 1:
      return ChainName.MAINNET;

    case 3:
      return ChainName.ROPSTEN;

    case 4:
      return ChainName.RINKEBY;

    case 5:
      return ChainName.GÖRLI;

    case 42:
      return ChainName.KOVAN;

    case 10:
      return ChainName.OPTIMISM;

    case 69:
      return ChainName.OPTIMISTIC_KOVAN;

    case 42161:
      return ChainName.ARBITRUM_ONE;

    case 421611:
      return ChainName.ARBITRUM_RINKEBY;

    case 137:
      return ChainName.POLYGON;

    case 80001:
      return ChainName.POLYGON_MUMBAI;

    case 42220:
      return ChainName.CELO;

    case 44787:
      return ChainName.CELO_ALFAJORES;

    case 100:
      return ChainName.GNOSIS;

    case 1284:
      return ChainName.MOONBEAM;

    default:
      throw new Error("Unknown chain id: ".concat(id));
  }
};
export var CHAIN_IDS_LIST = Object.values(ChainId).map(function (c) {
  return c.toString();
});
export var ID_TO_PROVIDER = function ID_TO_PROVIDER(id) {
  switch (id) {
    case ChainId.MAINNET:
      return process.env.JSON_RPC_PROVIDER;

    case ChainId.ROPSTEN:
      return process.env.JSON_RPC_PROVIDER_ROPSTEN;

    case ChainId.RINKEBY:
      return process.env.JSON_RPC_PROVIDER_RINKEBY;

    case ChainId.GÖRLI:
      return process.env.JSON_RPC_PROVIDER_GORLI;

    case ChainId.KOVAN:
      return process.env.JSON_RPC_PROVIDER_KOVAN;

    case ChainId.OPTIMISM:
      return process.env.JSON_RPC_PROVIDER_OPTIMISM;

    case ChainId.OPTIMISTIC_KOVAN:
      return process.env.JSON_RPC_PROVIDER_OPTIMISTIC_KOVAN;

    case ChainId.ARBITRUM_ONE:
      return process.env.JSON_RPC_PROVIDER_ARBITRUM_ONE;

    case ChainId.ARBITRUM_RINKEBY:
      return process.env.JSON_RPC_PROVIDER_ARBITRUM_RINKEBY;

    case ChainId.POLYGON:
      return process.env.JSON_RPC_PROVIDER_POLYGON;

    case ChainId.POLYGON_MUMBAI:
      return process.env.JSON_RPC_PROVIDER_POLYGON_MUMBAI;

    case ChainId.CELO:
      return process.env.JSON_RPC_PROVIDER_CELO;

    case ChainId.CELO_ALFAJORES:
      return process.env.JSON_RPC_PROVIDER_CELO_ALFAJORES;

    default:
      throw new Error("Chain id: ".concat(id, " not supported"));
  }
};
export var WRAPPED_NATIVE_CURRENCY = (_WRAPPED_NATIVE_CURRE = {}, _defineProperty(_WRAPPED_NATIVE_CURRE, ChainId.MAINNET, new Token(1, '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', 18, 'WETH', 'Wrapped Ether')), _defineProperty(_WRAPPED_NATIVE_CURRE, ChainId.ROPSTEN, new Token(3, '0xc778417E063141139Fce010982780140Aa0cD5Ab', 18, 'WETH', 'Wrapped Ether')), _defineProperty(_WRAPPED_NATIVE_CURRE, ChainId.RINKEBY, new Token(4, '0xc778417E063141139Fce010982780140Aa0cD5Ab', 18, 'WETH', 'Wrapped Ether')), _defineProperty(_WRAPPED_NATIVE_CURRE, ChainId.GÖRLI, new Token(5, '0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6', 18, 'WETH', 'Wrapped Ether')), _defineProperty(_WRAPPED_NATIVE_CURRE, ChainId.KOVAN, new Token(42, '0xd0A1E359811322d97991E03f863a0C30C2cF029C', 18, 'WETH', 'Wrapped Ether')), _defineProperty(_WRAPPED_NATIVE_CURRE, ChainId.OPTIMISM, new Token(ChainId.OPTIMISM, '0x4200000000000000000000000000000000000006', 18, 'WETH', 'Wrapped Ether')), _defineProperty(_WRAPPED_NATIVE_CURRE, ChainId.OPTIMISTIC_KOVAN, new Token(ChainId.OPTIMISTIC_KOVAN, '0x4200000000000000000000000000000000000006', 18, 'WETH', 'Wrapped Ether')), _defineProperty(_WRAPPED_NATIVE_CURRE, ChainId.ARBITRUM_ONE, new Token(ChainId.ARBITRUM_ONE, '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1', 18, 'WETH', 'Wrapped Ether')), _defineProperty(_WRAPPED_NATIVE_CURRE, ChainId.ARBITRUM_RINKEBY, new Token(ChainId.ARBITRUM_RINKEBY, '0xB47e6A5f8b33b3F17603C83a0535A9dcD7E32681', 18, 'WETH', 'Wrapped Ether')), _defineProperty(_WRAPPED_NATIVE_CURRE, ChainId.POLYGON, new Token(ChainId.POLYGON, '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270', 18, 'WMATIC', 'Wrapped MATIC')), _defineProperty(_WRAPPED_NATIVE_CURRE, ChainId.POLYGON_MUMBAI, new Token(ChainId.POLYGON_MUMBAI, '0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889', 18, 'WMATIC', 'Wrapped MATIC')), _defineProperty(_WRAPPED_NATIVE_CURRE, ChainId.CELO, new Token(ChainId.CELO, '0x471EcE3750Da237f93B8E339c536989b8978a438', 18, 'CELO', 'Celo native asset')), _defineProperty(_WRAPPED_NATIVE_CURRE, ChainId.CELO_ALFAJORES, new Token(ChainId.CELO_ALFAJORES, '0xF194afDf50B03e69Bd7D057c1Aa9e10c9954E4C9', 18, 'CELO', 'Celo native asset')), _defineProperty(_WRAPPED_NATIVE_CURRE, ChainId.GNOSIS, WXDAI_GNOSIS), _defineProperty(_WRAPPED_NATIVE_CURRE, ChainId.MOONBEAM, WGLMR_MOONBEAM), _WRAPPED_NATIVE_CURRE);

function isMatic(chainId) {
  return chainId === ChainId.POLYGON_MUMBAI || chainId === ChainId.POLYGON;
}

var MaticNativeCurrency = /*#__PURE__*/function (_NativeCurrency) {
  _inherits(MaticNativeCurrency, _NativeCurrency);

  var _super = _createSuper(MaticNativeCurrency);

  function MaticNativeCurrency(chainId) {
    _classCallCheck(this, MaticNativeCurrency);

    if (!isMatic(chainId)) throw new Error('Not matic');
    return _super.call(this, chainId, 18, 'MATIC', 'Polygon Matic');
  }

  _createClass(MaticNativeCurrency, [{
    key: "equals",
    value: function equals(other) {
      return other.isNative && other.chainId === this.chainId;
    }
  }, {
    key: "wrapped",
    get: function get() {
      if (!isMatic(this.chainId)) throw new Error('Not matic');
      var nativeCurrency = WRAPPED_NATIVE_CURRENCY[this.chainId];

      if (nativeCurrency) {
        return nativeCurrency;
      }

      throw new Error("Does not support this chain ".concat(this.chainId));
    }
  }]);

  return MaticNativeCurrency;
}(NativeCurrency);

function isCelo(chainId) {
  return chainId === ChainId.CELO_ALFAJORES || chainId === ChainId.CELO;
}

var CeloNativeCurrency = /*#__PURE__*/function (_NativeCurrency2) {
  _inherits(CeloNativeCurrency, _NativeCurrency2);

  var _super2 = _createSuper(CeloNativeCurrency);

  function CeloNativeCurrency(chainId) {
    _classCallCheck(this, CeloNativeCurrency);

    if (!isCelo(chainId)) throw new Error('Not celo');
    return _super2.call(this, chainId, 18, 'CELO', 'Celo');
  }

  _createClass(CeloNativeCurrency, [{
    key: "equals",
    value: function equals(other) {
      return other.isNative && other.chainId === this.chainId;
    }
  }, {
    key: "wrapped",
    get: function get() {
      if (!isCelo(this.chainId)) throw new Error('Not celo');
      var nativeCurrency = WRAPPED_NATIVE_CURRENCY[this.chainId];

      if (nativeCurrency) {
        return nativeCurrency;
      }

      throw new Error("Does not support this chain ".concat(this.chainId));
    }
  }]);

  return CeloNativeCurrency;
}(NativeCurrency);

function isGnosis(chainId) {
  return chainId === ChainId.GNOSIS;
}

var GnosisNativeCurrency = /*#__PURE__*/function (_NativeCurrency3) {
  _inherits(GnosisNativeCurrency, _NativeCurrency3);

  var _super3 = _createSuper(GnosisNativeCurrency);

  function GnosisNativeCurrency(chainId) {
    _classCallCheck(this, GnosisNativeCurrency);

    if (!isGnosis(chainId)) throw new Error('Not gnosis');
    return _super3.call(this, chainId, 18, 'XDAI', 'xDai');
  }

  _createClass(GnosisNativeCurrency, [{
    key: "equals",
    value: function equals(other) {
      return other.isNative && other.chainId === this.chainId;
    }
  }, {
    key: "wrapped",
    get: function get() {
      if (!isGnosis(this.chainId)) throw new Error('Not gnosis');
      var nativeCurrency = WRAPPED_NATIVE_CURRENCY[this.chainId];

      if (nativeCurrency) {
        return nativeCurrency;
      }

      throw new Error("Does not support this chain ".concat(this.chainId));
    }
  }]);

  return GnosisNativeCurrency;
}(NativeCurrency);

function isMoonbeam(chainId) {
  return chainId === ChainId.MOONBEAM;
}

var MoonbeamNativeCurrency = /*#__PURE__*/function (_NativeCurrency4) {
  _inherits(MoonbeamNativeCurrency, _NativeCurrency4);

  var _super4 = _createSuper(MoonbeamNativeCurrency);

  function MoonbeamNativeCurrency(chainId) {
    _classCallCheck(this, MoonbeamNativeCurrency);

    if (!isMoonbeam(chainId)) throw new Error('Not moonbeam');
    return _super4.call(this, chainId, 18, 'GLMR', 'Glimmer');
  }

  _createClass(MoonbeamNativeCurrency, [{
    key: "equals",
    value: function equals(other) {
      return other.isNative && other.chainId === this.chainId;
    }
  }, {
    key: "wrapped",
    get: function get() {
      if (!isMoonbeam(this.chainId)) throw new Error('Not moonbeam');
      var nativeCurrency = WRAPPED_NATIVE_CURRENCY[this.chainId];

      if (nativeCurrency) {
        return nativeCurrency;
      }

      throw new Error("Does not support this chain ".concat(this.chainId));
    }
  }]);

  return MoonbeamNativeCurrency;
}(NativeCurrency);

export var ExtendedEther = /*#__PURE__*/function (_Ether) {
  _inherits(ExtendedEther, _Ether);

  var _super5 = _createSuper(ExtendedEther);

  function ExtendedEther() {
    _classCallCheck(this, ExtendedEther);

    return _super5.apply(this, arguments);
  }

  _createClass(ExtendedEther, [{
    key: "wrapped",
    get: function get() {
      if (this.chainId in WRAPPED_NATIVE_CURRENCY) return WRAPPED_NATIVE_CURRENCY[this.chainId];
      throw new Error('Unsupported chain ID');
    }
  }], [{
    key: "onChain",
    value: function onChain(chainId) {
      var _a;

      return (_a = this._cachedExtendedEther[chainId]) !== null && _a !== void 0 ? _a : this._cachedExtendedEther[chainId] = new ExtendedEther(chainId);
    }
  }]);

  return ExtendedEther;
}(Ether);
ExtendedEther._cachedExtendedEther = {};
var cachedNativeCurrency = {};
export function nativeOnChain(chainId) {
  if (cachedNativeCurrency[chainId] != undefined) return cachedNativeCurrency[chainId];
  if (isMatic(chainId)) cachedNativeCurrency[chainId] = new MaticNativeCurrency(chainId);else if (isCelo(chainId)) cachedNativeCurrency[chainId] = new CeloNativeCurrency(chainId);else if (isGnosis(chainId)) cachedNativeCurrency[chainId] = new GnosisNativeCurrency(chainId);else if (isMoonbeam(chainId)) cachedNativeCurrency[chainId] = new MoonbeamNativeCurrency(chainId);else cachedNativeCurrency[chainId] = ExtendedEther.onChain(chainId);
  return cachedNativeCurrency[chainId];
}